var _desc, _rect, _circle, _rect2, _path, _circle2, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogSalesforceIntegration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 700",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Salesforce integration strategy illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Salesforce CRM connected to ERP, website, API, and reporting systems.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "#061427"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 350,
    r: 155,
    fill: "#0ea5e9",
    opacity: 0.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 250,
    width: 290,
    height: 200,
    rx: 36,
    fill: "#0f172a",
    stroke: "#38bdf8",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535 335c23-55 105-55 130 0m-164 58c42-66 157-66 198 0",
    fill: "none",
    stroke: "#22d3ee",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 320,
    r: 42,
    fill: "#14b8a6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 95,
    width: 230,
    height: 135,
    rx: 26,
    fill: "#132f45"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 95,
    width: 230,
    height: 135,
    rx: 26,
    fill: "#132f45"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 470,
    width: 230,
    height: 135,
    rx: 26,
    fill: "#132f45"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 470,
    width: 230,
    height: 135,
    rx: 26,
    fill: "#132f45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M340 163l115 130M860 163L745 293M340 538l115-130M860 538L745 408",
    stroke: "#14b8a6",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160 145h130M160 180h92M910 145h130M910 180h92M160 520h130M160 555h92M910 520h130M910 555h92",
    stroke: "#cbd5e1",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M535 508h130",
    stroke: "#38bdf8",
    strokeWidth: 13,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogSalesforceIntegration);
export default __webpack_public_path__ + "static/media/blog-salesforce-integration.9f62a720debb8a238aff695d4890cbc6.svg";
export { ForwardRef as ReactComponent };